// extracted by mini-css-extract-plugin
export var bCorpCopy = "b-corp-copy-module--bCorpCopy--2dpvL";